function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35 37c-2.203 0-4-1.797-4-4 0-2.203 1.797-4 4-4 2.203 0 4 1.797 4 4 0 2.203-1.797 4-4 4z",
  fill: "#37474F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 15l6.133 11A7.935 7.935 0 0 1 35 25c4.41 0 8 3.59 8 8s-3.59 8-8 8a7.982 7.982 0 0 1-6.238-3",
  fill: "none",
  strokeWidth: 4,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  stroke: "#37474F",
  strokeOpacity: 1,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 33H22c0 4.41-3.59 8-8 8s-8-3.59-8-8c0-3.719 2.555-6.855 6-7.746",
  fill: "none",
  strokeWidth: 4,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  stroke: "#37474F",
  strokeOpacity: 1,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 37c-2.203 0-4-1.797-4-4 0-2.203 1.797-4 4-4 2.203 0 4 1.797 4 4 0 2.203-1.797 4-4 4z",
  fill: "#E91E63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 19c-2.203 0-4-1.797-4-4 0-2.203 1.797-4 4-4 2.203 0 4 1.797 4 4 0 2.203-1.797 4-4 4z",
  fill: "#37474F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 33l6.813-11.188A8.004 8.004 0 0 1 17 15c0-4.41 3.59-8 8-8s8 3.59 8 8c0 .7-.09 1.383-.262 2.031",
  fill: "none",
  strokeWidth: 4,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  stroke: "#E91E63",
  strokeOpacity: 1,
  strokeMiterlimit: 10
}));

const SvgWebhook = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWebhook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/webhook.b05058f8.svg";
export { ForwardRef as ReactComponent };